import { render, staticRenderFns } from "./restriktionen-year-view.vue?vue&type=template&id=3c0a4dce&scoped=true"
import script from "./restriktionen-year-view.vue?vue&type=script&lang=js"
export * from "./restriktionen-year-view.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-year-view.vue?vue&type=style&index=0&id=3c0a4dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a4dce",
  null
  
)

export default component.exports